module.exports = __webpack_public_path__ + "fd7dc6f099d0944bc4a3679cb7c0ebf8.svg";